import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {DMESGLOG_ROOT} from "./dmesglogData";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})
export class DmesglogDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<DMESGLOG_ROOT> {
    this.uiUrl = this.url.GetDmesgLogUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<DMESGLOG_ROOT>(this.uiUrl);
  }


}

